import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const DocumentListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const HeaderWrapper = styled.div`
  background-color: #004c83;
  display: flex;
  justify-content: space-between;
  padding: 18px 30px;
`;

export const Title = styled.h2`
  color: white;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0;
  font-weight: normal;
  text-transform: uppercase;
`;

export const AddCenterProducts = styled.button`
  background-color: transparent;
  border: 1px solid white;
  border-radius: 4px;
`;

export const OuterWrapper = styled.div`
  padding: 2rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:30px;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
`;

export const GridLoaderItem = styled.div`
  text-align: center;
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const CategoryDetail = styled.div`
  font-size: 14px;
  font-style: italic;
  margin-bottom: 10px;
  color: #767676 !important;
`;

export const ActionButtons = styled.div`
  justify-self: end;
`;

export const ButtonWrapper = styled.div`
  justify-self: end;
`;

export const ButtonWrapperRelative = styled.div`
  justify-self: end;
  position: relative;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => props.colour};
  border: 1px solid ${(props) => props.colour};
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  white-space: nowrap;
  border-bottom-left-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
  border-bottom-right-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
`;

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding: 0 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
}
`;

export const SliderGridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: 1.25rem;
}
`;

export const TransportDetail = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #767676 !important;
`;

export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
`;

export const GlobalSearch = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductLabel = styled.div`
  font-style: italic;
  color: #474747 !important;
  font-size: 14px;
  font-weight: 600;
`;

export const AuthorContainer = styled.span`
  font-size: 14px;
  color: #767676;
  margin-left: 10px;
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 16px;
  line-height: 34px;
  color: #084987 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;

export const NoDocument = styled.span`
  font-family: Lato;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: #cccccc;
`;
